import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { SzTileTrendDirection, SzTileVariant } from './sz-tile.types';

@Component({
  selector: 'sz-tile',
  templateUrl: './sz-tile.component.html',
  styleUrls: ['./sz-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class SzTileComponent {
  readonly label: InputSignal<string> = input.required<string>();
  readonly value: InputSignal<string | number> = input.required<string | number>();
  readonly unit: InputSignal<string | null> = input<string | null>(null);
  readonly variant: InputSignal<SzTileVariant> = input<SzTileVariant>('default');
  readonly trend: InputSignal<string | null> = input<string | null>(null);
  readonly trendDirection: InputSignal<SzTileTrendDirection> = input<SzTileTrendDirection>('neutral');
  readonly trendBaseline: InputSignal<string | null> = input<string | null>(null);
}
